import {
    THUMBNAILICON,
    THUMBNAILICON_SUCCESS,
    THUMBNAILICON_ERROR
} from "../constants/thumbnailIconConstants";


const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};


function thumbnailIconReducer(state = initialState, action) {
    switch (action.type) {
        case THUMBNAILICON:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'loadingTitle': 'THUMBNAILS',
                'loadingMessage': 'THE THUMBNAILS ARE BEING LOADED',
                'error': ''

            });
        case THUMBNAILICON_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case THUMBNAILICON_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'thumbnailIconData': action.data.icons

            });
        default:
            return state;
    }
};

export default thumbnailIconReducer